import {type EventEmitter, type FunctionalComponent, h} from '@stencil/core';
import type {SearchProduct} from '../../../../../api/model/response/documents/public/Product';
import type { SearchDocumentUnionUiTypeModel } from '../../../../../models/ui/documents/search-document-union-ui-type.model';
import type {PrsmProduct} from '../../../../../api/model/response/documents/public/PrsmDocument';
import { getValidatedPrice, type ResultCardType } from '../../public/product-card/helpers/helpers';
import {Area} from '../../public/product-card/types/newProductCard.type';
import {ucOptions} from '../../utils/ucOptions';

export interface GenericCardEventsLayer {
    clickEmitter: EventEmitter;
    index: number;
    doc: SearchProduct | PrsmProduct | SearchDocumentUnionUiTypeModel;
    resutCardType?: ResultCardType;
    section?: string;
}

export const GenericCardEventsLayer: FunctionalComponent<GenericCardEventsLayer> = (props, children) => {
    const {index,doc, resutCardType, section} = props;
    const {url, commStatus, circularNature} = props.doc;
    const price = 'price' in props.doc ? getValidatedPrice(props.doc.price) : '';
    const currency = 'currency' in doc ? doc.currency : '';
    const quantity = 'quantity' in doc ? doc.quantity : 1;
    const totalPrice = price ? +price * (+quantity || 1) : '';
    function enrichEventWithData(e) {
        const elementsWithAreas = [...e.composedPath().filter(el => el.dataset?.cardArea)];

        return {
          searchResultPosition: index,
          rightButton: e.button !== 0,
          openUrl: getItemHrefAsUrl(elementsWithAreas) || url,
          clickedArea: getClickedArea(elementsWithAreas),
          clickType: getClickType(e),
          commStatus: commStatus,
          product: window.location.hostname,
          title: doc.title,
          id: doc['id'],
          category: (doc as SearchProduct).category?.CT_CAT,
          resutCardType: resutCardType,
          section,
          circularNature,
          price,
          currency,
          quantity,
          totalPrice
        };
    }

    function getClickType (e): 'left' | 'right' | 'Enter' {
        if (e.key === 'Enter') {
          return e.key;
        }
        if (e.button === 0) {
          return 'left';
        } else {
          return 'right';
        }
    }

    function getClickedArea (elementsWithAreas) {

        const clickedAreas = elementsWithAreas.map(el=> el.dataset.cardArea);

        return clickedAreas[0];
    }

    function getItemHrefAsUrl (elementsWithAreas) {
        return elementsWithAreas[0]?.href ?? false;
    }

    function onClickEventEmit(e) {
        const elementsWithAreas = [...e.composedPath().filter(el => el.dataset?.cardArea)];

        if(elementsWithAreas.some(el => [Area.DROPDOWN, Area.CHECKBOX, ucOptions.ADD_TO_MY_CART, ucOptions.ADD_TO_MY_LIST]
          .includes(el.dataset.cardArea))) {
          return;
        }

        if(elementsWithAreas.length > 0
          && elementsWithAreas[0].dataset.skipClickEvent
          && elementsWithAreas[0].dataset.skipClickEvent === 'true') {
          return;
        }
        props.clickEmitter.emit({...enrichEventWithData(e)});
    }

    return <host onMouseDown={(e) => onClickEventEmit(e)}
      onKeyDown={e => {
          if (e.key === 'Enter') {
            onClickEventEmit(e);
          }
      }}>{children}</host>;
};
